import styled from "styled-components/macro"
import { Icon } from "@humanpredictiveintelligence/myqvt-library"

export const ScopeIcon = styled(Icon).attrs(props => ({
  name: "location_off",
}))`
  vertical-align: bottom;
`
